import { useQuery } from '@tanstack/react-query';
const buildPipeline = (siteId) => {
    return [{ $match: { c_site: siteId } }];
};
export const useSiteInternalSigners = ({ apiClient, accountId, siteId }) => {
    const fetchSigners = async () => {
        if (!apiClient || !siteId) {
            return [];
        }
        const pipeline = JSON.stringify(buildPipeline(siteId));
        const params = { pipeline, expand: 'c_account' };
        try {
            const response = await apiClient.get(`/v2/routes/ec__site_signers/${siteId}`, {
                params,
            });
            return response?.data?.data ?? [];
        }
        catch (error) {
            const status = error?.response?.status;
            if (status !== 404 || !accountId) {
                throw error;
            }
            const fallback = await apiClient.get(`/v2/accounts/${accountId}/ec__site_signers`, {
                params,
            });
            return fallback?.data?.data ?? [];
        }
    };
    return useQuery({
        queryKey: ['ec__site_signers', siteId],
        queryFn: fetchSigners,
        enabled: !!apiClient && !!siteId,
        refetchOnWindowFocus: false,
    });
};
